const UndoIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8" cy="8" r="7.25" stroke="#BEBEBE" strokeWidth="1.5" />
    <path
      d="M4.5 8.5L7 11L12 5.5"
      stroke="#BEBEBE"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default UndoIcon;
